import { getTranslationDictionarySchema, TranslationDictionary } from '../translate/translation-dictionary.model';

export interface QualityCheckItem {
  id: string;

  qualityCheckItemTemplateId: string;

  name: string;
  nameTranslation: TranslationDictionary;
  code: string;
  order: number;
  comment: string;
  commentTranslation: TranslationDictionary;
  reference: string;
  referenceTranslation: TranslationDictionary;

  activityId: string;
  qualityCheckItemPhases: QualityCheckItemPhase[];
}

export interface QualityCheckItemPhase {
  id: string;
  phaseId: string;
  checked: boolean; // field is only used locally for form edit
}

export const qualityCheckItemChatbotFields = {
  id: { type: 'string' },
  activityId: { type: 'string', description: 'Required when adding.' },
  qualityCheckItemTemplateId: {
    type: 'string',
    description: 'Optional. Should be set if an item is bases on the template.',
  },
  code: {
    type: 'string',
    description: 'Required when adding. Otherwise should be only set if the intend is to change it.',
  },
  nameTranslation: getTranslationDictionarySchema(
    'Required for new entries. Othwerise should be only set if the intend is to change it.'
  ),
  commentTranslation: getTranslationDictionarySchema('Othwerise should be only set if the intend is to change it.'),
  referenceTranslation: getTranslationDictionarySchema('Othwerise should be only set if the intend is to change it.'),
  qualityCheckItemPhases: {
    type: 'array',
    items: {
      type: 'object',
      description: 'Quality check item phase assignment.',
      properties: {
        id: { type: 'string', description: 'Existing assignment id when updating an existing phase relation.' },
        phaseId: { type: 'string', description: 'Project phase id.' },
        checked: { type: 'boolean', description: 'Whether the quality check item applies to this phase.' },
      },
    },
  },
  order: { type: 'number' },
};
